import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { colors, fontWeight, ReskinThemes } from '../constants';
import PrimaryPalette from '../../birch/colors';

const flavorStyles = (flavor, themeName) => {
  const flavorMapping =
    themeName !== ReskinThemes.BIRCH
      ? flavorStyles.styles
      : flavorStyles.birchStyles;
  return flavorMapping[flavor] || {};
};

flavorStyles.birchStyles = {
  warning: {
    backgroundColor: PrimaryPalette.extraLightYellow,
  },
  error: {
    backgroundColor: PrimaryPalette.extraLightPoppy,
  },
  success: {
    backgroundColor: PrimaryPalette.extraLightGreen,
  },
  neutral: {
    backgroundColor: PrimaryPalette.extraLightIris,
  },
};

flavorStyles.styles = {
  warning: {
    backgroundColor: colors.canaryYellow,
    borderColor: colors.darkYellow,
  },
  error: {
    backgroundColor: colors.almostVeryLightRed,
    borderColor: colors.darkRed,
  },
  success: {
    backgroundColor: colors.budgieGreen,
    borderColor: colors.mediumGreenhouseGreen,
  },
  neutral: {
    backgroundColor: colors.babyBlue,
    borderColor: colors.darkBlue,
  },
};

const sizeStyles = (size) => {
  return sizeStyles.styles[size] || {};
};

sizeStyles.styles = {
  small: {
    fontSize: '12px',
    padding: '10px 15px',
  },
  normal: {
    fontSize: '14px',
    padding: '14px 22px',
  },
};

const VALID_FLAVORS = Object.keys(flavorStyles.styles);
const VALID_SIZES = Object.keys(sizeStyles.styles);

const FeedbackBlock = styled.div`
  background-color: ${(props) =>
    flavorStyles(props.flavor, props.theme?.name).backgroundColor};
  padding: ${(props) => sizeStyles(props.size).padding};
  font-size: ${(props) => sizeStyles(props.size).fontSize};
  line-height: 1.5;
  border-radius: ${(props) =>
    props.theme?.name !== ReskinThemes.BIRCH ? `2` : `5`}px;
  ${(props) =>
    props.theme?.name !== ReskinThemes.BIRCH &&
    `border: solid 1px ${
      flavorStyles(props.flavor, props.theme?.name).borderColor
    };`}
  margin-bottom: 15px;
  position: relative;
  ${(props) =>
    props.width
      ? css`
          width: ${props.width};
        `
      : ''}
`;

FeedbackBlock.displayName = 'FeedbackBlock';

FeedbackBlock.propTypes = {
  flavor: PropTypes.oneOf(VALID_FLAVORS).isRequired,
  size: PropTypes.oneOf(VALID_SIZES),
  width: PropTypes.string,
};

FeedbackBlock.defaultProps = {
  size: 'normal',
};

const FeedbackBlockTitle = styled.div`
  font-size: 14px;
  ${fontWeight('normal')};
`;

FeedbackBlockTitle.displayName = 'FeedbackBlockTitle';

const FeedbackBlockBody = styled.div`
  font-size: 12px;
  color: ${colors.darkGrey};
`;

FeedbackBlockBody.displayName = 'FeedbackBlockBody';

export default FeedbackBlock;

export { FeedbackBlock, FeedbackBlockTitle, FeedbackBlockBody };
